import React from "react";
import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";

export default function PortfolioPackageRow({
    item,
    isActive = false,
    onSelect,
    onTogglePublished,
    sortableDisabled = false,
}) {
    const sortable = useSortable({ id: item.id, disabled: sortableDisabled });
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = sortable;

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.6 : 1,
        cursor: sortableDisabled ? "pointer" : "grab",
    };

    return (
        <article
            ref={setNodeRef}
            style={style}
            className={`package-card${isActive ? " package-card--active" : ""}`}
            onClick={() => onSelect?.(item.id)}
            {...attributes}
            {...listeners}
        >
            <div className="package-card__header">
                <span className="package-card__badge">{item.cardTitle}</span>
                <h3 className="package-card__title">{item.title}</h3>
            </div>
            <p className="package-card__summary">{item.cardSummary}</p>
            <div className="package-card__meta">
                {(item.meta ?? []).slice(0, 2).map((metaItem, index) => (
                    <span key={`${item.id}-meta-${index}`}>{metaItem}</span>
                ))}
            </div>
            <div className="package-card__footer">
                <button
                    type="button"
                    className={`package-card__status${item.published === false ? " package-card__status--draft" : ""}`}
                    onClick={(event) => {
                        event.stopPropagation();
                        onTogglePublished?.(item.id);
                    }}
                >
                    {item.published === false ? "Taslak" : "Yayında"}
                </button>
                <button
                    type="button"
                    className="package-card__action"
                    onClick={(event) => {
                        event.stopPropagation();
                        onSelect?.(item.id);
                    }}
                >
                    Düzenle
                </button>
            </div>
        </article>
    );
}
